import type { ReactNode } from 'react';

import s from './EventDateGroup.module.scss';

const DAY_ABBR = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

interface EventDateGroupProps {
  date: Date;
  children: ReactNode;
}

export function EventDateGroup({ date, children }: EventDateGroupProps) {
  return (
    <div className={s.dayGroup}>
      <div className={s.dayLabel}>
        <span className={s.dayAbbr}>{DAY_ABBR[date.getDay()]}</span>
        <span className={s.dayNumber}>{date.getDate()}</span>
      </div>
      <div className={s.items}>{children}</div>
    </div>
  );
}
